<template>
  <el-dialog :visible.sync="visibleModal" title="批量充值/转账结果" width="960px">
    <el-form class="ghost-button-styles" label-width="110px">
      <el-form-item label="处理方式">
        <el-radio-group disabled :value="result.taskType">
          <el-radio-button v-for="item in batchTypeList" :key="item.value" ghost :label="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-table class="common-el-table-styles" height="320" :data="result.taskList" border ref="tableRef">
      <el-table-column label="序号">
        <template slot-scope="{ $index }">
          <div>{{ $index + 1 }}</div>
        </template>
      </el-table-column>

      <template v-if="result.taskType === batchTypeEnum.RECHARGE">
        <el-table-column
          v-for="col in rechargeResultCols"
          :key="col.key"
          :prop="col.key"
          :label="col.title"
          show-overflow-tooltip
        ></el-table-column>
      </template>

      <template v-if="result.taskType === batchTypeEnum.TRANSFER_IN">
        <el-table-column
          :class-name="`${col.className} parent-col`"
          v-for="col in transferInTableCols"
          :key="col.key"
          :prop="col.key"
          :label="col.title"
        >
          <el-table-column v-for="c in col.children" :key="c.key" :prop="c.key" :label="c.title" show-overflow-tooltip> </el-table-column>
        </el-table-column>
      </template>

      <template v-if="result.taskType === batchTypeEnum.TRANSFER_OUT">
        <el-table-column
          :class-name="`${col.className} parent-col`"
          v-for="col in transferOutTableCols"
          :key="col.key"
          :prop="col.key"
          :label="col.title"
        >
          <el-table-column v-for="c in col.children" :key="c.key" :prop="c.key" :label="c.title" show-overflow-tooltip> </el-table-column>
        </el-table-column>
      </template>

      <el-table-column label="操作" fixed="right">
        <template slot-scope="{ row }">
          <div class="btns">
            <span style="color: green" v-if="row.result.msg === '成功'">
              <em class="el-icon-success"></em>
              成功
            </span>

            <span class="error" v-else>
              <span>
                <em class="el-icon-error"></em>
                <span>失败</span>
                <el-tooltip popper-class="result-error-msg-popover" effect="dark" :content="row.result.msg">
                  <em v-if="row.result.msg" style="margin-left: 5px" class="el-icon-warning-outline"></em>
                </el-tooltip>
              </span>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer">
      <el-button type="primary" @click="visibleModal = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  transferOutNormalResultCols,
  transferOutSpecialResultCols,
  transferInSpecialResultCols,
  transferInNormalResultCols,
  rechargeResultCols
} from './table-cols.js'

import { batchTypeEnum, batchTypeList } from './data.js'

export default {
  props: {
    result: {
      type: Object
    },
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      batchTypeEnum,
      batchTypeList,
      rechargeResultCols
    }
  },
  computed: {
    hasToutiao() {
      return this.result.taskList?.some((item) => item.mediaId === 10)
    },
    hasGdt() {
      return this.result.taskList?.some((item) => item.mediaId === 16)
    },
    showSpecialCols() {
      return this.hasGdt || this.hasToutiao
    },

    transferOutTableCols() {
      if (this.showSpecialCols) return transferOutSpecialResultCols
      return transferOutNormalResultCols
    },
    transferInTableCols() {
      if (this.showSpecialCols) return transferInSpecialResultCols
      return transferInNormalResultCols
    },

    visibleModal: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.btns {
  .error {
    color: red;
  }
}
::v-deep .el-table {
  thead .transfer-bg-highlight {
    background: rgb(214, 235, 255) !important;
  }
  thead .parent-col {
    .cell {
      justify-content: center;
      font-weight: 700;
    }
  }
}
</style>
